module.exports = __webpack_public_path__ + "static/media/7-item-b.917e7bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/7-item-b.jpg
// module id = 1207
// module chunks = 33